__turbopack_context__.v({
  "btn__close": "MyListQueryParamPopup-module-scss-module__oFaqGa__btn__close",
  "my_list_query_param_popup": "MyListQueryParamPopup-module-scss-module__oFaqGa__my_list_query_param_popup",
});
